module.exports = __webpack_public_path__ + "img/OBCINA VRHNIKA.d3bbcd4f.png";